import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "store/store";
import WelcomePage from "pages/welcome/welcome-page/WelcomePage";
import NewFeedLeftSidebar from "components/app/new-feed-post/NewFeedLeftSidebar";
import NewFeedPostComponent from "components/app/new-feed-post/NewFeedPostComponent";
import NewFeedRightSidebar from "components/app/new-feed-post/NewFeedRightSidebar";
import NewFeedStories from "components/app/new-feed-post/NewFeedStories";
import ShimmerLoader from "components/app/new-feed-post/ShimmerLoader";
import { AppRecordStatusJK, RouteUrl, StatusMsg } from "utils";
import { AppLog } from "services";
import { PostReaction } from "models/postReaction";
import DialogPostReaction from "components/app/dialog/DialogPostReaction";
import { ShimmerNewFeedLoadingMore } from "components/app/shrimmer/Shrimmer";

import { newFeedStore } from "store/newFeedStore";
import NewFeedDailogShare from "components/app/new-feed-post/new-feed-components/new-feed-dialogs/NewFeedDialogShare";
import DialogNewFeedPost from "components/app/dialog/dialog-new-feed-post/DialogNewFeedPost";
import { useLocation, useSearchParams } from "react-router-dom";
import PostOption from "components/app/post-option/PostOption";
import { Service } from "utils/services";
import NewFeedDailogBlock from "components/app/new-feed-post/new-feed-components/new-feed-dialogs/NewFeedDialogBlock";
import NewFeedDailogDeletePost from "components/app/new-feed-post/new-feed-components/new-feed-dialogs/NewFeedDialogDeletePost";
import NewFeedDialogReportPost from "components/app/new-feed-post/new-feed-components/new-feed-dialogs/NewFeedDialogReportPost";
import appStore from "store/appStore";
import NewFeedDialogBoostPost from "components/app/new-feed-post/new-feed-components/new-feed-dialogs/NewFeedDialogBoostPost";

export default function NewsFeed() {
  const { isAuthenticated } = useSelector((state: RootState) => state.auth);

  const location = useLocation();
  const [searchParams] = useSearchParams();

  const postId = searchParams.get("post_id");

  const {
    posts,
    appRecord,
    initializePage,
    fetchPosts,
    onClickedShare,
    onClickedLike,
    onClickedFollow,

    connectorUsers,
    connectorUsersLoading,
    birthdayUsers,
    birthdayUsersLoading,
    lastActiveShopId,

    onPostUpdate,
  } = newFeedStore();

  const { onOpenDialogPostModal, onCloseDialogPostModal, onCloseDialogViewStoryModal, showDialogUploadEditPostContent } = appStore();

  const observerRef = useRef<HTMLDivElement | null>(null);

  const [dialogPostReaction, setDialogPostReaction] = useState({
    isOpen: false,
    post: null,
    postReaction: PostReaction.like,
  });

  const [dialogShare, setDialogShare] = useState({
    isOpen: false,
    post: null,
  });

  const [dialogNewFeedPost, setDialogNewFeedPost] = useState<{
    isOpen: boolean;
    post: any | null;
    video: HTMLVideoElement | null;
    videoCurrentTime: number;
    videoIsPlaying: boolean;
    playerControlRef?: React.MutableRefObject<{
      pause: () => void;
      play: () => void;
      goLive: () => void;
    } | null>;
  }>({
    isOpen: false,
    post: null,
    video: null,
    videoCurrentTime: 0,
    videoIsPlaying: false,
  });

  const [postOption, setPostOption] = useState<{
    isOpen: boolean;
    buttonRef: HTMLButtonElement | null;
    post: any;
  }>({
    isOpen: false,
    buttonRef: null,
    post: null,
  });

  const onOpenReactionDialog = (post: any, postReaction: PostReaction) => {
    try {
      setDialogPostReaction({
        isOpen: true,
        post: post,
        postReaction,
      });
    } catch (error) {
      AppLog.show({
        message: `[onOpenReactionDialog]`,
        status: StatusMsg.error,
        error,
      });
    }
  };

  const onOpenDialogShare = (post: any) => {
    try {
      setDialogShare({
        isOpen: true,
        post: post,
      });
    } catch (error) {
      AppLog.show({
        message: `[onOpenDialogShare]`,
        status: StatusMsg.error,
        error,
      });
    }
  };

  const onOpenDialogNewFeedPost = (
    post: any,
    video: HTMLVideoElement | null,
    playerControlRef?: React.MutableRefObject<{
      pause: () => void;
      play: () => void;
      goLive: () => void;
    } | null>
  ) => {
    try {
      setDialogNewFeedPost({
        isOpen: true,
        post: post,
        video: video,
        videoCurrentTime: video?.currentTime ?? 0,
        videoIsPlaying: video ? !video.paused : false,
        playerControlRef: playerControlRef,
      });
      if (video) {
        video.pause();
      }

      if (playerControlRef?.current) {
        playerControlRef.current?.pause();
      }
    } catch (error) {
      AppLog.show({
        message: `[onOpenDialogNewFeedPost]`,
        status: StatusMsg.error,
        error,
      });
    }
  };

  const onOpenPostOption = (e: React.MouseEvent<HTMLButtonElement>, post: any) => {
    setPostOption({
      isOpen: true,
      buttonRef: e.currentTarget,
      post: post,
    });
  };

  const onClosePostOption = () => {
    setPostOption({
      isOpen: false,
      buttonRef: null,
      post: null,
    });
  };

  const loadMorePosts = async () => {
    if (appRecord.canLoadMore() === false) return;

    setTimeout(async () => {
      fetchPosts(false);
    }, 500);
  };

  // * ------ Some Dialog ------- * //
  const [dialogBlock, setDialogBlock] = useState({
    isOpen: false,
    post: null,
    optionKey: "",
  });

  const onOpenDialogBlock = (post: any, optionKey: string) => {
    try {
      setDialogBlock({
        isOpen: true,
        post: post,
        optionKey: optionKey,
      });
    } catch (error) {
      AppLog.show({
        message: `[onOpenDialogBlock]`,
        status: StatusMsg.error,
        error,
      });
    }
  };

  const [dialogDeletePost, setDialogDeletePost] = useState({
    isOpen: false,
    post: null,
  });

  const onOpenDialogDeletePost = (post: any) => {
    try {
      setDialogDeletePost({
        isOpen: true,
        post: post,
      });
    } catch (error) {
      AppLog.show({
        message: `[onOpenDialogDeletePost]`,
        status: StatusMsg.error,
        error,
      });
    }
  };

  const [dialogReportPost, setDialogReportPost] = useState({
    isOpen: false,
    post: null,
  });

  const onOpenDialogReportPost = (post: any) => {
    try {
      setDialogReportPost({
        isOpen: true,
        post: post,
      });
    } catch (error) {
      AppLog.show({
        message: `[onOpenDialogReportPost]`,
        status: StatusMsg.error,
        error,
      });
    }
  };

  const [dialogBoostPost, setDialogBoostPost] = useState({
    isOpen: false,
    post: null,
  });

  const onOpenDialogBoostPost = (post: any) => {
    try {
      setDialogBoostPost({
        isOpen: true,
        post: post,
      });
    } catch (error) {
      AppLog.show({
        message: `[onOpenDialogBoostPost]`,
        status: StatusMsg.error,
        error,
      });
    }
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && appRecord.loadingStatus === AppRecordStatusJK.loaded) {
          loadMorePosts();
        }
      },
      { rootMargin: "1000px" }
    );

    if (observerRef.current) {
      observer.observe(observerRef.current);
    }

    return () => {
      observer.disconnect();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [appRecord.loadingStatus]);

  useEffect(() => {
    if (!postId && location.pathname === RouteUrl.newsFeed) {
      if (Service.userAuth) {
        initializePage();
      }
    } else {
      console.log(`[INFO] Skipping initialization because we are in a modal view.`);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [postId, location.pathname]);

  useEffect(() => {
    const handlePopState = () => {
      onCloseDialogPostModal();
      onCloseDialogViewStoryModal();
    };

    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {isAuthenticated ? (
        <div className="bg-background min-h-screen flex justify-center">
          {/* Left Sidebar (Hidden for Now) */}
          <div className="hidden lg:block lg:w-1/4 xl:w-[18%] p-2 sticky right-0 top-[80px] left-0 h-[calc(100vh-80px)] z-0">
            <NewFeedLeftSidebar
              connectorUsers={connectorUsers}
              connectorUsersLoading={connectorUsersLoading}
              birthdayUsers={birthdayUsers}
              birthdayUsersLoading={birthdayUsersLoading}
              lastActiveShopId={lastActiveShopId}
            />
          </div>

          {/* Center Feed (Main Scrollable Area - Uses Window Scroll) */}
          <div className="w-full lg:max-w-2xl xl:max-w-[700px] p-2">
            {/* ✅ Show Shimmer Loader When First Loading */}
            {appRecord.isLoading() ? (
              <div className="space-y-4">
                <ShimmerLoader />
                <ShimmerLoader />
                <ShimmerLoader />
              </div>
            ) : (
              <>
                {/* Stories Section */}
                <NewFeedStories />

                {/* Post Contents */}

                <div>
                  {posts.map((post, index) => (
                    <div key={post.provider_post_id} className="mb-4">
                      <NewFeedPostComponent
                        post={post}
                        onOpenReactionDialog={onOpenReactionDialog}
                        onOpenDialogShare={onOpenDialogShare}
                        onOpenDialogNewFeedPost={onOpenDialogNewFeedPost}
                        onOpenPostOption={onOpenPostOption}
                        onClickedLike={onClickedLike}
                        onClickedFollow={onClickedFollow}
                        onOpenPostModal={(postId) => onOpenDialogPostModal(postId, RouteUrl.newsFeed)}
                        tmpRouteUrl={RouteUrl.newsFeed}
                      />
                    </div>
                  ))}

                  <div ref={observerRef}>{appRecord.isLoadingMore() && <ShimmerNewFeedLoadingMore />}</div>
                </div>
              </>
            )}
          </div>

          {/* Right Sidebar (Hidden for Now) */}

          <div className="hidden lg:block w-auto lg:w-1/4 xl:w-[18%] p-2 sticky top-[80px] right-0 h-[calc(100vh-80px)] z-0 ">
            <NewFeedRightSidebar />
          </div>
        </div>
      ) : (
        <WelcomePage />
      )}

      {dialogPostReaction.isOpen && (
        <DialogPostReaction
          post={dialogPostReaction.post}
          isDialogOpen={dialogPostReaction.isOpen}
          postReaction={dialogPostReaction.postReaction}
          setIsDialogOpen={(isOpen) => setDialogPostReaction({ ...dialogPostReaction, isOpen })}
        />
      )}

      {dialogShare.isOpen && (
        <NewFeedDailogShare
          post={dialogShare.post}
          onSuccess={(post) => onClickedShare(post)}
          isDialogOpen={dialogShare.isOpen}
          setIsDialogOpen={(isOpen) => setDialogShare({ ...dialogShare, isOpen })}
        />
      )}

      {dialogNewFeedPost.isOpen && (
        <DialogNewFeedPost
          postProp={dialogNewFeedPost.post}
          isDialogOpen={dialogNewFeedPost.isOpen}
          videoCurrentTime={dialogNewFeedPost.videoCurrentTime}
          videoIsPlaying={dialogNewFeedPost.videoIsPlaying}
          setIsDialogOpen={(isOpen, videoCurrentTime, videoIsPlaying, isOpenPostModal) => {
            try {
              if (dialogNewFeedPost.video) {
                dialogNewFeedPost.video.currentTime = videoCurrentTime;
                if (videoIsPlaying && isOpenPostModal === false) dialogNewFeedPost.video.play();
              }

              if (dialogNewFeedPost.playerControlRef?.current && isOpenPostModal === false) {
                dialogNewFeedPost.playerControlRef?.current.goLive();
              }

              if (isOpenPostModal) {
                onOpenDialogPostModal(dialogNewFeedPost.post.post_id, RouteUrl.newsFeed);
              }

              setDialogNewFeedPost({
                ...dialogNewFeedPost,
                isOpen,
                video: null,
                videoCurrentTime: 0,
                videoIsPlaying: false,
              });
            } catch (error) {
              AppLog.show({
                message: `[setIsDialogOpen]`,
                status: StatusMsg.error,
                error,
              });
            }
          }}
          onOpenPostModal={(postId) => {}}
        />
      )}

      {/* Modals */}

      {dialogBlock.isOpen && (
        <NewFeedDailogBlock
          post={dialogBlock?.post}
          isDialogOpen={dialogBlock.isOpen}
          optionKey={dialogBlock.optionKey}
          setIsDialogOpen={(isOpen) => setDialogBlock({ ...dialogBlock, isOpen })}
        />
      )}

      {dialogBoostPost.isOpen && (
        <NewFeedDialogBoostPost
          post={dialogBoostPost?.post}
          isDialogOpen={dialogBoostPost.isOpen}
          setIsDialogOpen={(isOpen) => setDialogBoostPost({ ...dialogBoostPost, isOpen })}
        />
      )}

      {dialogDeletePost.isOpen && (
        <NewFeedDailogDeletePost
          post={dialogDeletePost?.post}
          isDialogOpen={dialogDeletePost.isOpen}
          setIsDialogOpen={(isOpen) => setDialogDeletePost({ ...dialogDeletePost, isOpen })}
        />
      )}

      {dialogReportPost.isOpen && (
        <NewFeedDialogReportPost
          post={dialogReportPost?.post}
          isDialogOpen={dialogReportPost.isOpen}
          setIsDialogOpen={(isOpen) => setDialogReportPost({ ...dialogReportPost, isOpen })}
        />
      )}

      {postOption.isOpen && (
        <PostOption
          isOpen={postOption.isOpen}
          onOpenChange={(_) => onClosePostOption()}
          post={postOption.post}
          buttonRef={postOption.buttonRef}
          handleOptionClick={(post, optionKey) => {
            if (optionKey === "share") {
              onOpenDialogShare(post);
            } else if (optionKey === "block_user") {
              onOpenDialogBlock(post, optionKey);
            } else if (optionKey === "boring_user") {
              onOpenDialogBlock(post, optionKey);
            } else if (optionKey === "delete") {
              onOpenDialogDeletePost(post);
            } else if (optionKey === "report") {
              onOpenDialogReportPost(post);
            } else if (optionKey === "boost_post") {
              onOpenDialogBoostPost(post);
            } else if (optionKey === "edit_post") {
              if (post.media_type === "photo" || post.media_type === "album" || post.media_type === "video") {
                showDialogUploadEditPostContent(post, (updatePost) => onPostUpdate(updatePost));
              }
            }
          }}
        />
      )}
    </>
  );
}
